import { Component, Input, OnInit } from "@angular/core";
import { MemberService } from "app/service/member/member.service";

@Component({
  selector: "modal-thirdParty",
  templateUrl: "./modal-thirdParty.component.html",
  styleUrls: ["../modal.component.scss", "./modal-thirdParty.component.scss"],
})
export class ModalThirdPartyComponent implements OnInit {
  constructor(private memberService: MemberService) {}

  ngOnInit() {
    if (this.isVisible) {
      document.body.style.overflow = "hidden";
    }
  }

  async handleSubmit() {
    await this.memberService.setPolicy({
      thirdParty: this.agree === "true",
    });
    this.modal.showThirdParty = false;
    document.body.style.overflow = "";
  }

  @Input()
  get modal() {
    return this._modal;
  }
  set modal(data) {
    this._modal = data;
  }
  private _modal = {
    showPrivacy: false,
    showThirdParty: false,
  };

  get isVisible() {
    return !this.modal.showPrivacy && this.modal.showThirdParty;
  }

  agree: string;
}



// WEBPACK FOOTER //
// ./src/app/modal/thirdParty/modal-thirdParty.component.ts